// extracted by mini-css-extract-plugin
export var articleList = "article-preview-module--article-list--pjL0a";
export var link = "article-preview-module--link--Hg6gs";
export var meta = "article-preview-module--meta--HPhQ8";
export var title = "article-preview-module--title--vFhz+";